import { scrollbarCSS } from '--floponents-web/common/scrollbarCss';
import styled, { css } from 'styled-components';

const SurfaceBody = styled.div<{ disablePadding?: boolean, rowSpacing?: boolean | number }>`
    position: relative;
    flex: 1 1 auto; /* Expand to fill available height of surface */
    margin: ${props => props.disablePadding ? props.theme.spacing(-2) : props.theme.spacing(0, -1)};
    overflow: auto;
    ${scrollbarCSS()};
    scrollbar-gutter: stable both-edges;

    ${props => props.rowSpacing ? css`
        &>*:not(:last-child) {
            margin-bottom: ${props.theme.spacing(typeof props.rowSpacing === "number" ? props.rowSpacing : 2)};
        }
    ` : null}
`;

export default SurfaceBody;
export { SurfaceBody };